<div id="form-container">
  @if (form) {
  <form [formGroup]="form" id="main-form" class="col col-m-7 col-l-8 col-xl-8 col-xxl-7 lpb-8" (ngSubmit)="onSubmit()">
    <h3 class="ui-heading-3-bold">VVPM Activity</h3>
    
    <div id="metadata">
      <h4 class="ui-heading-4--m">Metadata</h4>

      <!-- Name -->
      <app-expandable-input label="Name" [control]="form.controls.name" [data-testid]="'name'"></app-expandable-input>

      <!-- VVPM Number -->
      <rds-form-field labelPosition="side-left">
        <rds-control-label>VVPM Number</rds-control-label>
        <input rdsInput [value]="vvpmActivity().document_number__v" readonly class="monospace" />
      </rds-form-field>

      <!-- Status -->
      @if(vvpmActivity().status__v) {
        <rds-form-field labelPosition="side-left">
          <rds-control-label>Status</rds-control-label>
          <input rdsInput [value]="vvpmActivity().status__v" readonly />
        </rds-form-field>
      }

      <!-- Document Creation Date -->
      <rds-form-field labelPosition="side-left">
        <rds-control-label>Document Creation Date</rds-control-label>
        <input rdsInput [value]="formatDate(vvpmActivity().document_creation_date__v)" readonly />
      </rds-form-field>

      <!-- Expiration Date -->
      <rds-form-field labelPosition="side-left">
        <rds-control-label>Expiration Date</rds-control-label>
        <input rdsInput [value]="formatDate(vvpmActivity().expiration_date__c)" readonly />
      </rds-form-field>

      <!-- Filename -->
      <app-expandable-input label="Filename" [control]="form.controls.filename" [data-testid]="'filename'"></app-expandable-input>

      <rds-divider></rds-divider>

      <!-- Link to VVPM - Only show for Approved status -->
      @if (vvpmActivity().display_status === 'Approved') {
        <div id="vvpm-link">
          <section id="vvpm-link-section">
            <div id="vvpm-link-row" style="display: flex; align-items: center; justify-content: space-between;">
              <p id="vvpm-link-header" class="rds-form-field__label list-label" style="margin: 0;">
                Veeva Vault
              </p>
              <div id="vvpm-link-content">
                <button rds-text-button type="button" (click)="openVeevaVault()">
                  Open in Veeva Vault
                  <rds-icon namespace="filled" icon="link"></rds-icon>
                </button>
              </div>
            </div>
          </section>
        </div>

        <rds-divider></rds-divider>
      }

      <!-- Strategic Pillars & Audiences Section -->
      <div class="pillars-audiences-section">
        <div class="field-group">
          <!-- Strategic Pillars (Editable) -->
          <div class="field-row">
            <label class="rds-form-field__label">Strategic Pillars</label>
            <div class="field-control">
              <app-strategic-pillar-selector
                entityType="vvpm_activity"
                [entityId]="vvpmActivity().abstractID"
                [isViewer]="isViewer"
                (pillarChanged)="onPillarChanged($event)">
              </app-strategic-pillar-selector>
            </div>
          </div>

          <!-- Veeva Audiences (Read-only from Veeva PromoMats) -->
          <div class="field-row">
            <label class="rds-form-field__label">Audiences</label>
            <div class="field-control">
              <div class="veeva-audiences-list">
                @if (getCombinedAudiences().length === 0) {
                  <rds-form-field labelPosition="side-left">
                    <input rdsInput [value]="'None'" readonly disabled />
                  </rds-form-field>
                } @else {
                  @for (audience of getCombinedAudiences(); track audience) {
                    <rds-form-field labelPosition="side-left">
                      <input rdsInput [value]="audience" readonly disabled />
                    </rds-form-field>
                  }
                }
                <p class="veeva-sync-note">From Veeva PromoMats (Auto-synced)</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Visibility Toggle (Only for Editors/Admins) -->
      @if(!isViewer){
        <rds-divider></rds-divider>
        <div id="editable">
          <rds-switch formControlName="isVisible" labelPosition="before" [checked]="form.controls.isVisible">Visible for viewers?</rds-switch>
        </div>
      }
    </div>

    <!-- Submit Button (Only for Editors/Admins) -->
    @if(!isViewer) {
      <button rds-primary-button class="ms-auto" type="submit" [disabled]="isLoadingChanges()" data-testid="submit">
        @if (!isLoadingChanges()) {
          Save Changes
        } @else {
          Saving...
        }
      </button>
    }
  </form>
  }
</div>
